import React from 'react';
import { Mail } from 'lucide-react';

const ReadyForServiceCard: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-800 to-blue-900 rounded-2xl p-8 text-white shadow-2xl border border-blue-700">
      <div className="text-center">
        <h3 className="text-2xl font-bold mb-2 text-white">Thank You, Colorado &mdash; We&rsquo;re Closed</h3>
        <p className="text-lg mb-6 text-blue-100">
          After 8 years and 18,000+ jobs, Colorado First Plumbing and Sewer LLC closed in March 2026.
        </p>

        <div className="flex justify-center items-center mb-6">
          <a
            href="mailto:contact@bestmasterplumber.com"
            className="bg-white text-blue-900 hover:bg-yellow-50 hover:scale-[1.02] px-8 py-4 rounded-full text-lg font-bold inline-flex items-center justify-center transition-all duration-300 shadow-lg"
          >
            <Mail className="mr-2" size={20} />
            contact@bestmasterplumber.com
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-blue-100 text-sm">
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">&check;</span>
            </div>
            <span>Master Plumber Owned</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">&check;</span>
            </div>
            <span>360 Google Reviews (4.8&#9733;)</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">&check;</span>
            </div>
            <span>18,000+ jobs completed</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">&check;</span>
            </div>
            <span>Family-owned since 2018</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadyForServiceCard;
